import React from 'react';

import { Button } from '@mui/material';

import useStyles from './styles';

interface Props {
    color?: 'black' | 'white';
    size?: 'small' | 'regular';
    fullWidth?: boolean;
    shadows?: boolean;
    className?: string;
}

const SupportButton: React.FC<Props> = ({ size = 'regular', fullWidth = false, color = 'black', className }) => {
    const { classes, cx } = useStyles();

    return (
        <Button
            disableElevation
            disableRipple
            variant="contained"
            color="inherit"
            fullWidth={fullWidth}
            className={cx(
                classes.root,
                {
                    [classes._small]: size === 'small',
                    [classes._regular]: size === 'regular',
                    [classes._black]: color === 'black',
                    [classes._white]: color === 'white'
                },
                className
            )}
            href={'https://vulners.com/company/contacts'}
        >
            {'Support'}
        </Button>
    );
};

export default SupportButton;
